export const TokenValidation = (status, message, childAlerta) => {
    if (status === false && message && message.includes('Token inválido!')) {
        childAlerta.current.retorno('Autenticação inválida!', 'error');
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    } else {
        throw new Error('Campos necessários não foram retornados pelo servidor!');
    }
};
